import React from 'react';
import { useNavigate } from 'react-router-dom';
import RefreshableOutlet from '../components/RefreshableOutlet';
import Navigation from '../components/Navigation';
import authService from '../services/authService';
import { IcLogOut } from '../theme/icons';
import Swal from '../theme/swal';
import ConnectivityFooter from '../offline/ConnectivityFooter';
import KI from '../theme/palette';

const MainLayout = () => {
  const navigate = useNavigate();
  
  const handleLogout = () => {
    Swal.fire({
      title: 'Logout Confirmation',
      text: 'Are you sure you want to logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: KI.peacock,
      cancelButtonColor: KI.coralDark,
      confirmButtonText: 'Yes, logout'
    }).then((result) => {
      if (result.isConfirmed) {
        authService.logout()
          .then(() => {
            Swal.fire(
              'Logged Out!',
              'You have been successfully logged out.',
              'success'
            );
            navigate('/login');
          })
          .catch(error => {
            console.error('Logout error:', error);
            Swal.fire(
              'Error!',
              'There was a problem logging out.',
              'error'
            );
          });
      }
    });
  };
  return (
    <div className="min-h-screen flex flex-col bg-light">
      <Navigation />
      <main className="flex-grow p-4 md:p-6">
        {/* Enveloppe IDENTIQUE à la prod (owner 2026-09-07) : ni `key={pathname}`
            ni `.kp-page`. Le remontage à chaque route rejouait un fondu de
            320 ms + une montée de 6 px sur TOUTE la page — y compris la barre
            d'onglets Nouvelle vente / Réservation / Historique, qui clignotait
            et bougeait à chaque bascule. Le changement de page est de nouveau
            instantané, comme en prod. Les règles §2 d'index.css restent en
            place mais ne s'appliquent plus (aucun élément ne porte .kp-page). */}
        <div className="max-w-7xl mx-auto">
          <RefreshableOutlet />
        </div>
      </main>
      <footer className="bg-gradient-to-r from-gray-900 to-black text-white p-4">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-3">
          <div className="mb-4 md:mb-0">
            <p className="text-center md:text-left">© {new Date().getFullYear()} Kipara POS. All rights reserved.</p>
          </div>
          {/* Connectivity footer: WiFi light + grey status line */}
          <ConnectivityFooter />
          <div className="flex items-center space-x-6">
            {/* Logout Button */}
            {authService.isAuthenticated() && (
              <button
                onClick={handleLogout}
                className="flex items-center whitespace-nowrap text-xs lg:text-sm xl:text-base text-white hover:text-red-400 transition-colors duration-200"
              >
                <IcLogOut className="mr-1" />
                <span>Logout</span>
              </button>
            )}
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MainLayout;
